export default "__VITE_PUBLIC_ASSET__fae3b44f__"